<template>
  <div id="app">
    <router-view :key="$route.fullPath" />
  </div>
</template>

<script>
export default {
  created() {},
};
</script>

<style>
#app {
}
@media screen and (max-width: 320px) {
  #app {
    overflow: auto;
    overflow-x: hidden;
  }
}
</style>

